import { useState } from "react";
import { Helmet } from "react-helmet";

export default function ThankyouFlow2() {
  return (
    <>
      <Helmet>
        <title>Data Management</title>
        <meta name="title" content="Data Management" />
        <meta name="description" content="Data Management" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Data Management" />
        <meta property="og:description" content="Data Management" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Data Management" />
      </Helmet>
      {/* Main Content */}
      <div id="pageThankyou-flow1">
        <main>
          <div className="wrapContent">
            <section id="pThankyouContent">
              <div className="bThankyouContent">
                <div className="bTop">
                  <div className="bContent">
                    <div className="bPic">
                      <img src="/assets/img/ci/img-check.svg" alt="" />
                    </div>
                    <div className="bDetails">
                      <div className="bTitle">
                        <h1>สำเร็จ!</h1>
                        <p>ขอบคุณที่สละเวลาตอบแบบสำรวจค่ะ</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="bBottom">
                  <p>
                    <span>หมายเหตุ</span> แบบสอบถามนี้จัดทำโดย...
                    <br />
                    ซึ่งคุณสามารถตรวจสอบข้อมูลเพิ่มเติมได้ที่ 08xxx-xxx หรือ
                    www.123.com
                  </p>
                </div> */}
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
